import {AlertService} from '../../shared/services/alert.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import {Assessment} from "../../shared/models/assessment";
import {Scale} from "../../shared/models/scale";
import {ScaleRange} from "../../shared/models/scale-range";
import {SaveMessages} from "../../shared/models/save-messages";
import {AssessmentService} from "../../shared/services/assessment.service";

class ScaleAvailableDisplay extends Scale {
  public available: boolean;
}

@Component({
  selector: 'app-scale-edit',
  templateUrl: './scale-edit.component.html',
  styleUrls: ['./scale-edit.component.css']
})
export class ScaleEditComponent implements OnInit {

  private _scale:Scale;
  private _messages:SaveMessages;
  private _assessment:Assessment;
  private _hasLoaded:boolean;

  constructor(private _assessmentService:AssessmentService
   ,private route:ActivatedRoute
   ,private alertService:AlertService
    ,private router:Router) { 
    this._scale = new Scale();
    this._scale.id = this._assessmentService.newId();
    this._hasLoaded = false;
  }

  

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let assessmentUid = params['uid'];
      let scaleId = params['scaleId'];
      this._assessmentService.getAssessment(assessmentUid)
        .then((assessment:Assessment) => {
          this._assessment = assessment;
          this._scale = assessment.scales.find((s) => s.id == scaleId);
          this._hasLoaded = true;
          if (!this._scale) {
            this.router.navigate(['/not-found']);
          }
        })
        .catch((error) => {
          this.alertService.error("There was an error loading the scale data. Check your internet connection and refresh the page.");
          console.error(error);
        })
    });
  }

  get hasLoaded() {
    return this._hasLoaded;
  }

  get scale() {
    return this._scale;
  }

  set scale(v:Scale) {
    this._scale = v;
  }

  get AvailableSubScales() :ScaleAvailableDisplay[] {

      let subScaleDisplayList = [];
      let availableScales = this._scale.getAvailableSubScales(this._assessment.scales);
      availableScales.forEach((available, scale) => {
        let subScaleDisplay = Object.assign(new ScaleAvailableDisplay(), scale);
        subScaleDisplay.available = available;
        subScaleDisplayList.push(subScaleDisplay);
      });
      return subScaleDisplayList;
  }

  get ScaleTypes() {
    return ["Sum","CriteriaThreshold", "Mean"]
  }

  toggleSubScale(scale:Scale) {
    if (this._scale.hasSubScale(scale)) {
      this._scale.removeSubScale(scale);
    }
    else {
      this._scale.addSubScale(scale);
    }
  }

  isSelected(subScale:Scale) {
    return this._scale.hasSubScale(subScale);
  }

  updateType(type:"Sum"|"CriteriaThreshold") {
    this._scale.type = type;
    if (type == "Sum") {
      this.scale.gradingData = {requiredQuestion:0,requiredScoreThreshold:0};
    }
  }

  save() {
		
		this._assessmentService.saveAssessment(this._assessment).then(() => {
      this.alertService.success("Scale Saved!");
    }).catch((error) => {
      this.alertService.error("Error occurred in saving. Please try again.");
      console.error(error);
		});
	}
	
	saveAndCreateNew() {
		this._assessmentService.saveAssessment(this._assessment).then((assessment) => {
				this._messages.saveSuccess = true;
        setTimeout(() => {
          // we replace the url so we our back button can handle saving properly.
          this.router.navigate(["../../", "new"], {relativeTo: this.route, replaceUrl: true});
        })
    })
    .catch((error) => {
      console.log(error);
      this.alertService.error("Error occurred in saving. Please try again.");
		});
	}

  deleteRange(range:ScaleRange) {
		if (!confirm("Are you sure you want to delete this range?")) {
			return; 
		}
		this.scale.removeRange(range);
		this._assessmentService.saveAssessment(this._assessment).then(() => {
      this.alertService.success("Range Deleted!");
    })
		.catch((error) => {
      console.log(error);
      this.alertService.success("Error occurred in deleting. Please try again.!");
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/admin/scale-edit/scale-edit.component.ts